if (!customElements.get('site-drawers')) {
  customElements.define(
    'site-drawers',
    class SiteDrawers extends window.BAO.CustomElement {
      MATCHES = {
        trigger: '[data-drawers-trigger]',
        subOpen: '[data-subdrawers-open]',
        subClose: '[data-subdrawers-close]',
        subDrawer: '[data-subDrawers-drawer]',
        close: '[data-drawers-close]',
        backdrop: `[data-site-drawers-el="backdrop"]`,
      }

      ELS = {
        body: document.body || document.documentElement,
        backdrop: `[data-site-drawers-el="backdrop"]`,
        drawers: document.querySelector('site-drawers'),
      }

      CLASSES = {
        activeClass: 'drw-Drawers-active',
        siteOverflowed: 'util-SiteOverflowed',
        drawersOpenUtility: 'util-DrawersOpen',
      }

      _activeDrawerKey = ''
      _activeSubDrawerKey = ''
      _previousSubDrawerKey = ''

      constructor () {
        super()

        window.drawers = this

        this.drawerKeys
          .filter(key => !this.triggerKeys.includes(key))
          .forEach(key =>
            console.info(`Drawer exists for ${key} but there is no trigger`)
          )
      }

      setupListeners () {
        super.setupListeners()

        this.listeners.add(
          document.documentElement,
          'click',
          this.handleClick.bind(this)
        )
      }

      handleClick (e) {
        const eventType = (() => {
          if (e.target.closest(this.MATCHES.trigger) !== null) {
            return 'TRIGGER'
          } else if (e.target.closest(this.MATCHES.close) !== null) {
            return 'CLOSE'
          } else if (e.target.closest(this.MATCHES.backdrop) !== null) {
            return 'BACKDROP'
          } else if (e.target.closest(this.MATCHES.subOpen) !== null) {
            return 'SUBOPEN'
          } else if (e.target.closest(this.MATCHES.subClose) !== null) {
            return 'SUBCLOSE'
          }

          return 'UNKNOWN'
        })()

        if (eventType === 'UNKNOWN') return
        e.preventDefault()

        if (eventType === 'TRIGGER') {
          const trigger = e.target.closest(this.MATCHES.trigger)
          const key = trigger.getAttribute('data-drawers-trigger')

          if (this.triggerKeys.includes(key)) {
            this.activeDrawerKey = key === this.activeDrawerKey ? '' : key
          }
        } else if (eventType === 'CLOSE' || eventType === 'BACKDROP') {
          this.activeDrawerKey = ''
        } else if (eventType === 'SUBOPEN') {
          const trigger = e.target.closest(this.MATCHES.subOpen)
          const key = trigger.getAttribute('data-subdrawers-open')
          const parent = trigger.closest(this.MATCHES.subDrawer)

          if (parent) {
            this.previousSubDrawerKey = parent.hasAttribute(
              'data-subdrawers-drawer'
            )
              ? parent.getAttribute('key')
              : ''
          } else {
            this.previousSubDrawerKey = ''
          }

          if (this.subTriggerKeys.includes(key)) {
            this.activeSubDrawerKey = key === this.activeSubDrawerKey ? '' : key
          }
        } else if (eventType === 'SUBCLOSE') {
          const trigger = e.target.closest(this.MATCHES.subDrawer)
          const key = trigger.getAttribute('key')
          const parent = trigger.closest(this.MATCHES.subDrawer)

          parent && (this.previousSubDrawerKey = '')

          this.deactivateSubDrawerKey = key
        }
      }

      set deactivateSubDrawerKey (key) {
        this._activeSubDrawerKey = ''

        this.subDrawers.forEach(subDrawer => {
          subDrawer.isOpen = subDrawer.key === key ? false : subDrawer.isOpen
        })
      }

      get drawers () {
        return window.BAO.utils.getElements(`site-drawer`)
      }

      get subDrawers () {
        return window.BAO.utils.getElements(`site-sub-drawer`)
      }

      get triggerKeys () {
        return window.BAO.utils
          .getElements(`[data-drawers-trigger]`)
          .map(el => el.getAttribute('data-drawers-trigger'))
      }

      get drawerKeys () {
        return window.BAO.utils
          .getElements(`[data-drawers-drawer]`)
          .map(el => el.getAttribute('key'))
      }

      get subTriggerKeys () {
        return window.BAO.utils
          .getElements(`[data-subdrawers-open]`)
          .map(el => el.getAttribute('data-subdrawers-open'))
      }

      get aDrawerIsOpen () {
        return this.drawers.some(drawer => drawer.isOpen)
      }

      get activeSubDrawerKey () {
        return this._activeSubDrawerKey
      }

      get activeDrawerKey () {
        return this._activeDrawerKey
      }

      get previousSubDrawerKey () {
        return this._previousSubDrawerKey
      }

      set previousSubDrawerKey (key) {
        this._previousSubDrawerKey = key
      }

      set activeSubDrawerKey (key) {
        this._activeSubDrawerKey = key

        this.subDrawers.forEach(subDrawer => {
          subDrawer.isOpen =
            subDrawer.key === key || subDrawer.key === this.previousSubDrawerKey
        })
      }

      set activeDrawerKey (key) {
        document.body.classList.remove(`drw-Drawers-${this.activeDrawerKey}`)

        this._activeDrawerKey = key
        this.drawers.forEach(drawer => (drawer.isOpen = drawer.key === key))

        this.ELS.drawers.classList.toggle(
          this.CLASSES.activeClass,
          this.aDrawerIsOpen
        )
        document.body.classList.toggle(
          this.CLASSES.siteOverflowed,
          this.aDrawerIsOpen
        )
        document.body.classList.toggle(
          this.CLASSES.drawersOpenUtility,
          this.aDrawerIsOpen
        )

        if (key !== '') {
          document.body.classList.add(`drw-Drawers-${key}`)
        }
      }
    }
  )
}
